import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 删除合作商品
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象
 */
export function deletePartnerGoods(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/partner.deletePartnerGoods',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}